<template>
  <InfoMessage
    icon="confetti"
    :title="title"
    :perex="perex"
    width="492"
    class="mx-auto"
    :show-close="false"
  >
    <template v-if="action.bannerImg" #action>
      <a :href="action.linkHref" target="_blank">
        <v-img contain :src="action.bannerImg" alt="" />
      </a>
    </template>
    <template v-else-if="action.buttonText" #action>
      <a class="btn btn-primary" :href="action.linkHref" target="_blank">{{ action.buttonText }}</a>
    </template>
  </InfoMessage>
</template>

<script>
import InfoMessage from '@/components/Atoms/InfoMessage';

export default {
  name: 'ThematicCounsellingThankYou',
  components: { InfoMessage },
  props: {
    title: {
      type: String,
      required: true
    },
    perex: {
      type: String,
      default: ''
    },
    action: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
